import { CasinoLegacyDeepLinkActionBase } from "../casino-legacy-deep-link-action-base";
import {
  CasinoFreeToPlayGameStage
} from "@sparkware/uc-sdk-core/lib/apps/casino-free-to-play/casino-free-to-play.interfaces";
import {AppIdentifiers, AreaType, TriggerType} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";

export class FreeToPlayDeeplinkAction extends CasinoLegacyDeepLinkActionBase {
  async execute(): Promise<void> {

    const id = this.descriptor.actionParams.id;

    let gameStage: CasinoFreeToPlayGameStage;
    switch (id) {
      case "1":
        gameStage = CasinoFreeToPlayGameStage.DailyWish;
        break;
      case "2":
        gameStage = CasinoFreeToPlayGameStage.DepositWheel;
        break;

      default:
        gameStage = CasinoFreeToPlayGameStage.MiniArena;
        break;
    }

    await this.services.messageBroker.channels.performAction.topics.openCasinoFreeToPlay.execute({
      launchInfo: {
        businessCorrelationID: this.services.tools.getGuid(),
        channel: {
          area: AreaType.externalClick,
          element: CHANNEL_ELEMENTS.deepLink,
          source: CHANNEL_SOURCE.casinoClient
        },
        appSpecificParameters: {
          gameStage: gameStage
        },
        sourceAppVersion: this.services.sdk.getSkin().getVersion(),
        sourceAppID: AppIdentifiers.CasinoClient,
        trigger: TriggerType.automaticFlow
      }
    });

    await this._executeNextAction();
  }


}